<template>
    <div class="login">
        <v-row style="text-align: center;justify-content: center;">
            <v-col cols="4">
<v-card>
                <div class="login-logo">
                    <img style="width: 200px;height: 200px" src="/trucks.png">
                </div>
                <v-card-text>
                    <v-form>
                        <v-select
                                outlined
                                :items="users"
                                label="کاربر"
                                v-model="mobile"
                                item-value="id"
                                item-text="name"
                        ></v-select>

                        <v-text-field
                                outlined
                                id="password"
                                v-on:keyup.enter="login"
                                label="رمز عبور"
                                name="password"
                                v-model="password"
                                type="password"
                        ></v-text-field>

                    </v-form>
                </v-card-text>
                <v-card-actions>

                    <v-btn color="primary" class="login-btn" v-on:click="login()">ورود</v-btn>
                </v-card-actions>
</v-card>
            </v-col>
        </v-row>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                errors: [],
                mobile: 0,
                password: "",
                users: [],
                msg: '',
            }
        },
        mounted() {
            this.get_users()
        },
        methods: {
            login() {
                if (this.mobile && this.password) {
                    let formData = new FormData();
                    formData.append("user_name", this.mobile);
                    formData.append("password", this.password);
                    let config = {
                        header: {
                            'Content-Type': 'multipart/form-data'
                        }
                    }
                    var self = this;
                    this.errors = [];
                    this.axios.post('/api/login', formData, config)
                        .then(response => {
                            if (response.data.error == 1) {
                                alert(response.data.msg);
                                // self.errors.push(self.msg);
                            }else{
                                localStorage.setItem("token", response.data.token);
                                localStorage.setItem("name", response.data.name);
                                localStorage.setItem("permissions", JSON.stringify(response.data.roles));
                                // localStorage.setItem("adminName", response.data.admin_name);
                                // localStorage.setItem("adminImage" , response.data.admin_image);
                                self.$router.push({path: '/home', params: {}})

                            }

                        }).catch(e => {
                        this.errors.push(e);

                    })

                }
            },

            get_users() {
                var self = this
                const formData = new FormData()
                // formData.append('id', this.selected_province);
                this.axios.post('/api/users/select', formData, {}).then(function (response) {

                    // items = content_cats.orders;
                    if (response.data.error == 0) {

                        self.users = response.data.data

                    } else {
                        self.$root.modal_component.show_danger_modal('خطا', response.data.msg)

                    }

                }).catch(function (error) {
                    self.$root.modal_component.show_danger_modal('خطا در ثبت', 'لطفا تمامی موارد را چک کنید')

                    console.log(error)
                })
            },


        },
    }
</script>
